import { useTranslation } from "react-i18next";
import {
  ContactDetailsSectionBreadcrumbs,
  ContactDetailsSectionBreadcrumbsProps,
} from "../ContactDetailsSectionBreadcrumbs";
import { ContactDetailsSections } from "../../../ContactsDialog";
import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { useMemo, useState } from "react";
import { ClipboardCheck } from "lucide-react";

export interface EligibilitySectionProps {
  enduser: TellescopeModelFromName<"endusers">;
}

export const EligibilitySection = ({ enduser }: EligibilitySectionProps) => {
  const [showSubmissionForm, setShowSubmissionForm] = useState(false);
  const { t } = useTranslation("contacts");

  const hasInsurance = enduser.insurance || enduser.insuranceSecondary;

  const { breadcrumbs, actionButtons } = useMemo<
    Pick<ContactDetailsSectionBreadcrumbsProps, "breadcrumbs" | "actionButtons">
  >(() => {
    const breadcrumbs: ContactDetailsSectionBreadcrumbsProps["breadcrumbs"] = [
      {
        title: t("Eligibility"),
        onClick: showSubmissionForm ? () => setShowSubmissionForm(false) : undefined,
      },
    ];
    if (showSubmissionForm) {
      breadcrumbs.push({ title: t("Submit Eligibility Check") });
    }

    const actionButtons: ContactDetailsSectionBreadcrumbsProps["actionButtons"] =
      showSubmissionForm || !hasInsurance
        ? undefined
        : [
            {
              hoverLabel: t("Submit Eligibility Check"),
              onClick: () => setShowSubmissionForm(true),
              icon: ClipboardCheck,
            },
          ];

    return { breadcrumbs, actionButtons };
  }, [showSubmissionForm, hasInsurance, t]);

  return (
    <div className="flex flex-col gap-4 overflow-y-hidden">
      <ContactDetailsSectionBreadcrumbs
        enduserId={enduser.id}
        breadcrumbs={breadcrumbs}
        actionButtons={actionButtons}
      />
      {showSubmissionForm ? (
        <ContactDetailsSections.EligibilitySubmissionForm
          contact={enduser}
          onSubmit={() => setShowSubmissionForm(false)}
          onCancel={() => setShowSubmissionForm(false)}
        />
      ) : (
        <ContactDetailsSections.EligibilitySection contact={enduser} />
      )}
    </div>
  );
};
